import { createSlice } from "@reduxjs/toolkit";
import {
  getLessonById,
  getLessons,
  getLessonByLessonId,
  getReservedLessons,
  updateLessons,
  teacherGetLessonByLessonId, createLessons
} from "redux/actions/lessons";

export interface Lessons {
  selectedLesson: any;
  loading: boolean;
  lessonDetails: any;
  lessonList: Array<any> | null;
  reservedLessonList: Array<any> | null;
  lessonCreateLoading: boolean;
  lessonUpdateLoading: boolean;
}

const initial: Lessons = {
  selectedLesson: null,
  loading: false,
  lessonDetails: null,
  lessonList: [],
  reservedLessonList: [],
  lessonCreateLoading: false,
  lessonUpdateLoading: false,
};

const formatLessonDetails = (data: any, expertDetails: any) => {
  const formatedData = {
    lessonId: data.lesson.id,
    lessonType: data.lesson.lesson_type,
    lessonLanguage: data.lesson.language_id,
    lessonLanguageObj: data.lesson.language,
    title: data.lesson.name,
    description: data.lesson.description,
    categorySelect: data.lesson?.tags || [],
    coverImage: data.lesson.thumbnail,
    lessons: data.topics.map((el: any) => ({
      id: el.id,
      lessonTitle: el.topic,
      lessonDescription: el.description,
      points: el.points,
      participants: el?.max_participate_count,
      enrollment_count: el?.enrollment_count || 0,
      estimatedLessonDuration:el?.estimated_lesson_duration,
      schedule: {
        id: el?.schedule?.id,
        schedule_id: el?.schedule?.schedule_id,
        uuid: el?.schedule?.uuid,
        ...el?.schedule,
      },
      dateTime: {
        formated:
          data.lesson.lesson_type === 2
            ? el?.schedule?.time
            : "",
      },
    })),
    createdDate: data.lesson.created_at,
    isFavourite: data.lesson.is_favourite,
    isOwner:data.lesson.is_owner,
    expert: {
      firstName: expertDetails.first_name,
      lastName: expertDetails.last_name,
      avatar: expertDetails.thumbnail,
      country: expertDetails.country.name,
      id: expertDetails.id,
      isBookmarked: expertDetails.is_bookmarked,
      rating: expertDetails.rating_value,
      summery: expertDetails.career_summary,
      countryCode: expertDetails.country.code,
      languages: expertDetails.languages,
    },
  };
  return formatedData;
};

export const lessonsSlice = createSlice({
  name: "lessons",
  initialState: initial,
  reducers: {
    setSelectedLesson(state, action) {
      state.selectedLesson = action.payload;
    },
    setLessonDetails(state, action) {
      state.lessonDetails = action.payload;
    },
    cleanDetails(state) {
      state.lessonDetails = null;
    },
  },
  extraReducers: (builder) => {

    // * get lesson by id
    builder.addCase(getLessonById.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLessonById.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedLesson = action.payload;
    });
    builder.addCase(getLessonById.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getLessons.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLessons.fulfilled, (state, action) => {
      state.loading = false;
      state.lessonList = action.payload;
    });
    builder.addCase(getLessons.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getLessonByLessonId.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getLessonByLessonId.fulfilled, (state, action) => {
      state.loading = false;
      const { res, expertDetails } = action.payload;
      const data = res.data;
      state.lessonDetails = formatLessonDetails(data, expertDetails);
    });
    builder.addCase(getLessonByLessonId.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(teacherGetLessonByLessonId.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(teacherGetLessonByLessonId.fulfilled, (state, action) => {
      state.loading = false;
      const { res, expertDetails } = action.payload;

      const data = res.data;
      state.lessonDetails = formatLessonDetails(data, expertDetails);
    });
    builder.addCase(teacherGetLessonByLessonId.rejected, (state, action) => {
      state.loading = false;
    });

    //get reserved lessons
    builder.addCase(getReservedLessons.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getReservedLessons.fulfilled, (state, action) => {
      state.loading = false;
      state.reservedLessonList = action.payload;
    });
    builder.addCase(getReservedLessons.rejected, (state, action) => {
      state.loading = false;
      state.reservedLessonList = [];
    });

    builder.addCase(updateLessons.pending, (state, action) => {
      state.lessonUpdateLoading = true;
    });
    builder.addCase(updateLessons.fulfilled, (state, action) => {
      state.lessonUpdateLoading = false;
      state.lessonDetails = null;
    });
    builder.addCase(updateLessons.rejected, (state, action) => {
      state.lessonUpdateLoading = false;
    });

    builder.addCase(createLessons.pending, (state, action) => {
      state.lessonCreateLoading = true;
    });
    builder.addCase(createLessons.fulfilled, (state, action) => {
      state.lessonCreateLoading = false;
      state.lessonDetails = null;
    });
    builder.addCase(createLessons.rejected, (state, action) => {
      state.lessonCreateLoading = false;
    });
  },
});

export const { setSelectedLesson, setLessonDetails, cleanDetails } =
  lessonsSlice.actions;

export default lessonsSlice.reducer;
